/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Merge_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Merging Event Groups Complete" |
*
* @param {Translation_Merge_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_success_toast = /** @type {((inputs?: Translation_Merge_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusion des groupes d'evenements terminee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenführung der Ereignisgruppen abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unione gruppi eventi completata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объединение групп событий завершено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusión de grupos de eventos completada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并事件组完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループの統合が完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूहों का विलय पूरा हुआ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fusão de grupos de eventos concluída")
	return /** @type {LocalizedString} */ ("Merging Event Groups Complete")
});